/*
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-07-22 19:28:00
 * @LastEditTime: 2022-10-08 16:29:00
 * @LastEditors: chenguobiao
 */
import { strictFetch } from './http'

// 获取试题
export async function getRandomQuestion(params) {
  return strictFetch({
    url: '/question/getRandomQuestion',
    method: 'POST',
    params,
  })
}
// 提交答案
export async function testQuestionSave(data) {
  return strictFetch({
    url: '/userTestQuestion/jsonSave',
    method: 'POST',
    data,
  })
}
// 查看最终结果
export async function getTestLogOne(params) {
  return strictFetch({
    url: '/userTestLog/getOne',
    method: 'POST',
    params,
  })
}

// 获取考试试题
export async function getUserTestQuestion(params) {
  return strictFetch({
    url: '/userTestQuestion/getList',
    method: 'POST',
    params,
  })
}
// 查询成功晋级结果排名情况
export async function getPromotionResult(params) {
  return strictFetch({
    url: '/index/getPromotionResult',
    method: 'POST',
    params,
  })
}
// 查询成功晋级结果排名情况
export async function postQuitExam(data) {
  return strictFetch({
    url: '/userTestQuestion/quitExam',
    method: 'POST',
    data,
  })
}
// 调用获取语音token
export async function getVoiceToken(data) {
  return strictFetch({
    url: '/index/getVoiceToken',
    method: 'POST',
    data,
  })
}
// 使用激活码
export async function useActivateCard(data) {
  return strictFetch({
    url: '/index/useActivateCard',
    method: 'POST',
    data,
  })
}
